module.exports = __webpack_public_path__ + "img/manducaLogoNegro.jpg.e05c01a8.png";